export const ProjectPayDetails = [
  {
    path: "/report-center/download/project-pay-details/list",
    name: "material-project-pay-details-list1",
    meta: { title: "项目支出明细" },
    component: () =>
      import(
        /* webpackChunkName: "project-repot" */ "@/views/report-center/project-pay-details/list/index.vue"
      ),
  },
];
